import { Component, AfterViewInit, Inject } from '@angular/core';
import { SessionStorageService } from 'src/app/core/services/storage/session-storage.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfigApiService } from 'src/app/core/services/mobile-api';

export interface DialogData {}

@Component({
	selector: 'op-accept-esign',
	templateUrl: './accept-esign.component.html',
	styleUrls: ['./accept-esign.component.scss']
})
export class AcceptEsignComponent implements AfterViewInit {
	clientName: string;
	esignEnabled: boolean;
	applicantIndex: number;

	constructor(
		private sessionStorageService: SessionStorageService,
		private configApiService: ConfigApiService,
		public dialogRef: MatDialogRef<AcceptEsignComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DialogData
	) {}

	ngOnInit(): void {
		this.configApiService.configZeusReadAloudsOptimizationEnabled().subscribe({
			next: (rsp) => {
				this.esignEnabled = rsp?.value;
			}
		});
	}

	ngAfterViewInit(): void {
		this.clientName = this.sessionStorageService.get('clientName');
		this.applicantIndex = this.sessionStorageService.get('applicantIndex');
	}

	onClick(): void {
		this.dialogRef.close(true);
	}

	onNoClick(): void {
		this.dialogRef.close(false);
	}
}
